export default (state={}, action) => {
    switch(action.type)
    {
        case 'SET_STATE_CHECK_HIDE_ROWS':
            return action.payload;
        default: return state;
    }
}